var map = {
	"./border1.png": "e73e",
	"./border2.png": "fdae",
	"./border3.png": "b705",
	"./border4.png": "77f7",
	"./border5.png": "3ef2",
	"./border6.png": "4ef2",
	"./borders1.png": "7241",
	"./borders2.png": "67e7",
	"./borders3.png": "8ef1",
	"./borders4.png": "e6da",
	"./borders5.png": "f582",
	"./borders6.png": "4537"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6cdc";